import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Tag } from 'antd';
import { Enumify } from 'enumify-ts';
import { ConsignmentImageKindEnum } from "../routes/consignments/api/Representation";
class ConsignmentImageKind extends Enumify() {
    description;
    static PICK_UP_DOCKET = new ConsignmentImageKind("Pick Up Docket");
    static OTHER_PHOTO = new ConsignmentImageKind("Other Photo");
    static COMPLETION_PHOTO = new ConsignmentImageKind("Delivery Photo");
    static _ = ConsignmentImageKind._closeEnum();
    constructor(description) {
        super();
        this.description = description;
    }
    renderTag() {
        return _jsx(Tag, { children: this.description });
    }
    static filtersArray() {
        let a = [];
        for (let t of ConsignmentImageKind.values) {
            a.push({ label: t.description, value: t.key });
        }
        return a;
    }
    static enumDescription(kindEnum) {
        const objEnum = ConsignmentImageKind.valueOf(kindEnum);
        if (objEnum) {
            return objEnum.description;
        }
        return "?Unknown Kind?";
    }
}
export default ConsignmentImageKind;
